import { ProductCarousel } from "@/src/components/ProductsCarousel";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Container } from "@mui/material";
import { ComponentProps, FC } from "react";

const carouselData = [
  {
    title:
      "Убезпечте себе та своїх близьких з надійною страховою компанією «ПЗУ Україна»",
    description:
      "Забезпечте себе та своїх близьких від непередбачених ситуацій.",
    ImageProps: { src: "/images/main_banner.jpg", alt: "Image" },
    actions: [],
  },
  {
    title: "Досліджуйте світ безпечно",
    description: "Застрахуй себе та своїх близьких під час подорожі.",
    ImageProps: { src: "/images/tourism_banner.jpg", alt: "Image" },
    actions: [{ title: "Купити онлайн", href: "/products/tourism" }], // туризм
  },
  {
    title: "Будьте спокійні у непередбачуваних ситуаціях на дорозі", // цивілка
    description: "Отримай найкраще страхування для своїх подорожей.",
    ImageProps: { src: "/images/civilka_banner.jpg", alt: "Image" },
    actions: [{ title: "Купити онлайн", href: "/products/oscpv" }],
  },
  {
    title: "Подорожуйте закордон на авто безпечено", // ЗК
    description: "Індивідуальні рішення для кожної подорожі.",
    ImageProps: { src: "/images/ZK_banner.jpg", alt: "Image" },
    actions: [{ title: "Купити онлайн", href: "/products/green-card" }],
  },
];

interface BanerSectionProps {
  sectionProps?: ComponentProps<"section">;
  banners: any[];
}

const BanerSection: FC<BanerSectionProps> = ({ sectionProps, banners }) => {
  return (
    <section
      className={cn(
        "max-md:py-0 md:h-[320px] lg:h-[405px] 2lg:h-[495px] md:max-w-[calc(100vw-48px)] 2lg:max-w-[1440px] md:w-fit md:mx-auto overflow-visible relative z-10",
        sectionProps?.className,
      )}
    >
      <Container
        className={
          "max-md:px-0 md:mx-0"
        }
      >
        <ProductCarousel options={banners || carouselData} />
      </Container>
    </section>
  );
};

export default BanerSection;
